/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, unauthedApi } from './core';

type ApiMethod = 'post' | 'put' | 'delete' | 'get';

interface ExecuteProps {
  auth?: boolean;

  method?: ApiMethod;

  path: string;

  payload?: Record<string, any>;

  responseType?: 'blob' | 'json' | 'arraybuffer';
}

export type ExecuteApiCall<Result = any> = (params: ExecuteProps) => Promise<Result>;

const methodToParser: {
  [key in ApiMethod]?: (payload: ExecuteProps['payload']) => ExecuteProps['payload'];
} = {
  delete: (payload) => ({ data: payload }),

  get: (payload) => ({ params: payload }),
};

function parsePayload({
  method = 'post',
  payload = {},
}: Pick<ExecuteProps, 'method' | 'payload'>): Record<string, any> {
  const parser = methodToParser[method];

  return parser?.(payload) || payload;
}

export const executeApiCall = async <Result>({
  path,
  payload = {},
  method = 'post',
  responseType,
  auth = true,
}: ExecuteProps): Promise<Result> => {
  const apiPayload = parsePayload({ method, payload });

  const instance = auth ? api : unauthedApi;

  const hasOnlyTwoParams = method === 'get';

  const configParams = hasOnlyTwoParams
    ? [{ ...apiPayload, responseType }]
    : [apiPayload, { responseType }];

  const { data } = await instance[method]<Result>(path, ...configParams);

  return data;
};
